import { Button, ModalBody, ModalFooter, ModalHeader, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BaseModal } from './BaseModal';

interface IUserProfileHaveActiveVisit {
  isOpen: boolean;
  onClose: VoidFunction;  
}

export const UserProfileHaveActiveVisit = (props: IUserProfileHaveActiveVisit) => {
  const { t } = useTranslation();
  return (
    <BaseModal {...props}>
      <>
        <ModalHeader>{t('modal.error.delete.profile.failed.by.active.session.caption')}</ModalHeader>

        <ModalBody>
          <Text>{t('modal.error.delete.profile.failed.by.active.session.text')}</Text>
        </ModalBody>

        <ModalFooter>
          <Button variant='linkUnderlinePrimary' size='sm' onClick={props?.onClose}>
            {t('ok')}
          </Button>
        </ModalFooter>
      </>
    </BaseModal>
  );
};
